'use client';

import React from 'react';
import {
  SortDropdownProps,
  SortOption,
} from '@src/v3/interfaces/components/coreUI/filterDropdown/sortDropdown';
import { SORT_OPTIONS } from '@src/v3/constants/sort';
import Button from '@src/v3/components/coreUI/button';
import clsx from 'clsx';

const SortDropdown: React.FC<SortDropdownProps> = ({
  selectedSort,
  onSortChange,
  containerClassName = '',
}) => {
  // Define sort options based on the Figma design

  const handleSortSelect = (sort: SortOption) => {
    onSortChange?.(sort.label);
  };

  const isSelected = (sort: SortOption) => {
    return selectedSort === sort.label;
  };

  return (
    <div className={containerClassName}>
      <div className="flex flex-col gap-y-8">
        {/* Header */}
        <div className="flex flex-col">
          <span className="text-xl font-medium text-black-dark">Sort</span>
        </div>

        {/* Sort Options */}
        <div className="flex flex-col gap-y-2.5">
          {SORT_OPTIONS.map((option) => {
            const Icon = option.icon;
            return (
              <Button
                key={option.id}
                onClick={() => handleSortSelect(option)}
                className={clsx(
                  isSelected(option)
                    ? 'border border-primary-dark bg-primary-lighter text-black-dark/90 hover:bg-primary-lighter'
                    : 'border-transparent bg-gray-lighter hover:bg-gray-light text-gray-dark ',
                  'w-max shadow-none px-4 py-3 h-11 flex items-center rounded-[100px] gap-x-2 text-base font-medium transition-colors flex-shrink-0'
                )}
              >
                <Icon width="16" height="16" />
                <span className="flex-1 text-left">{option.label}</span>
              </Button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SortDropdown;
